
const ENV = process.env.NODE_ENV
export default {
  DOMAIN: 'http://127.0.0.1:8080',
  baseURL: "https://admxwjybackend.csohu.cn",
  imageURL: "https://admxwjybackend.csohu.cn",
  // baseURL: "http://admxwjybackend.csohu.cn",
  // imageURL: "http://admxwjybackend.csohu.cn",
  // baseURL: "http://test.edujianshe.com",
  // imageURL: "http://test.edujianshe.com",
  util: {
    image: '/util/image.html' // 图片上传
  }
}



// WEBPACK FOOTER //
// ./src/api/api.url.js